export const formatCalendarDate = (value: string | null, fallback = '-'): string => {
  if (value === null) {
    return fallback;
  }
  return new Date(value).toLocaleDateString(undefined, { timeZone: 'UTC' });
};

export const formatTimestamp = (value: string | null, fallback = '-'): string => {
  if (value === null) {
    return fallback;
  }
  return new Date(value).toLocaleDateString();
};

export const toCalendarDateInputValue = (value: string | null): string => {
  if (value === null) {
    return '';
  }
  return value.slice(0, 10);
};
